module.exports = __webpack_public_path__ + "img/Aggregationen.ad2b882f.png";